import { Button, CircularProgress } from '@mui/material';
import React from 'react';

// A dialog button that is disabled with a spinner while its request runs (see hooks/useBusy)
const BusyButton = ({ busy, disabled, startIcon, children, ...props }) => (
    <Button {...props} disabled={busy || disabled} startIcon={busy ? <CircularProgress size={16} color="inherit" /> : startIcon}>
        {children}
    </Button>
);

export default BusyButton;
